export const PackageName = 'Doorman'
export const npmPackageName = 'react-native-doorman'
